import React from 'react';
import { ImageSlideShow } from 'Components/frameworks/image-slideshow/ImageSlideShow';
import {
  aggregateIconList,
  getBabyBedIconItem,
  getCapacityIconItem,
  getOutsideFacilitiesIconItem,
  getSurfaceIconItem,
  getViewIconItem,
} from 'Components/widgets/accommodations/BookingAccommodationsUtils';
import { AccommodationRoomInfos } from 'Components/widgets/accommodation-room/infos/AccommodationRoomInfos';
import { t } from 'Src/i18n';
type Props = {
  accommodations: Array<Accommodation>;
  resort: Product;
  roomQuantity: Array<number>;
};
export const AccommodationSummary = ({ accommodations, resort, roomQuantity }: Props) => {
  const accommodationsIds = accommodations.map((accommodation) => accommodation.id);
  const selectedAccommodations = resort.accommodations.filter((acc) =>
    accommodationsIds.includes(acc.id),
  );
  return selectedAccommodations.map<Node>((selectedAccommodation: Accommodation) => {
    const babyCount = selectedAccommodation.equipments?.some(
      (equipment) => equipment.id === 'MAT_baby_bed',
    )
      ? 1
      : selectedAccommodation.babyCount;
    const surfaceItem = getSurfaceIconItem(
      selectedAccommodation.roomType,
      resort,
      selectedAccommodation.surface,
    );
    const babyBedItem = getBabyBedIconItem(babyCount);
    const capacityItem = getCapacityIconItem(selectedAccommodation.maxCapacity);
    const outsideFacilityItem = getOutsideFacilitiesIconItem(
      selectedAccommodation.outsideFacilities,
    );
    const viewItem = getViewIconItem(selectedAccommodation.view);
    const items = aggregateIconList(
      selectedAccommodation.strengths,
      surfaceItem,
      capacityItem,
      outsideFacilityItem,
      viewItem,
      babyBedItem,
    );
    return (
      <div key={selectedAccommodation.id}>
        <div className="flex flex-col">
          <div className="mb-10 mt-30 sm:flex sm:flex-row sm:flex-wrap">
            <div className="relative sm:w-1/2 sm:pe-10 md:w-2/5">
              <ImageSlideShow
                className="flex flex-col items-center justify-center overflow-hidden rounded-12"
                hasInfiniteScroll
                hasLazyLoading
                media={selectedAccommodation.media.photos.map((photo) => {
                  return {
                    src: photo.url,
                  };
                })}
              />
            </div>
            <div className="flex flex-col pb-10 sm:w-1/2 sm:justify-between sm:pb-0 sm:ps-10 md:w-3/5">
              <div className="flex justify-between">
                <p className="text-blue mb-10 mt-10 font-brand text-18">
                  {selectedAccommodation.label}
                </p>
                {roomQuantity[0] > 1 && (
                  <p className="text-blue mb-10 mt-0 font-brand text-20">x{roomQuantity}</p>
                )}
              </div>
              <p className="mb-10 mt-0 text-14">{selectedAccommodation.description}</p>
              <p className="m-0 text-14">{t('common.details')}:</p>
              <AccommodationRoomInfos
                theme="column"
                items={items}
                isInMoreRoomLayer={false}
                isAccommodationSummary
              />
            </div>
          </div>
        </div>
        {selectedAccommodations.length > 1 &&
          selectedAccommodation !== selectedAccommodations[selectedAccommodations.length - 1] && (
            <div className="relative flex items-center py-40">
              <div className="grow border-t border-mediumGrey"></div>
              <span className="mx-4 shrink px-20 font-brand text-18 text-mediumGrey">&</span>
              <div className="grow border-t border-mediumGrey"></div>
            </div>
          )}
      </div>
    );
  });
};
